import script from "./AppReactions.vue?vue&type=script&setup=true&lang=js"
export * from "./AppReactions.vue?vue&type=script&setup=true&lang=js"

import "./AppReactions.vue?vue&type=style&index=0&id=cdcc4fde&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdcc4fde"]])

export default __exports__